// Lógica central de autorización por permiso en el frontend.
// Espejo del decorador backend `requirePermission`. La usan: el helper global $can (main.js),
// el guard del router (router.js) y el aterrizaje post-login (Login.vue).
import store from "../store";
import { buildMenuFromPermissions, menuFlags } from "../config/menuCatalog";

// hasPermission(code): true si el usuario tiene concedido el permiso.
// Fuente de verdad: getUser.settings.permissions (sembrado por `seed_permissions`).
// Fallback pre-seed (antes del backfill): admin ve todo, otros roles nada extra
// -> preserva el comportamiento histórico hasta que existan los permisos persistidos.
export function hasPermission(code) {
    const user = store.getters.getUser;
    const perms = user && user.settings && user.settings.permissions;
    if (Array.isArray(perms)) return perms.includes(code);
    return !!(user && user.role === "Administrador");
}

// firstAllowedRoute(): primera ruta que el usuario puede ver. Se usa como destino de
// aterrizaje tras login y como redirección cuando el guard bloquea una ruta sin permiso.
// Evita hardcodear rutas por rol.
export function firstAllowedRoute() {
    const user = store.getters.getUser;
    const settings = (user && user.settings) || {};
    // Menú congelado (§2.6): no se aterriza en una pantalla que el usuario no tiene en el menú.
    const visible = Array.isArray(settings.menu) ? settings.menu : null;
    const menu = buildMenuFromPermissions(hasPermission, {
        flags: menuFlags(settings),
        visible,
    });
    const routes = [];
    for (const section of menu) {
        for (const item of (section.items || [])) routes.push(item.to);
    }
    // El Panel de control es el home natural de quien puede verlo (dueño/admin). Se prioriza para
    // que el aterrizaje tras registro/login y la redirección del guard lleven ahí, aun si
    // `settings.landing` viniera ausente o desactualizado (sesiones viejas en localStorage).
    if (hasPermission('dashboard') && (!visible || visible.indexOf('/dashboard') !== -1)) return '/dashboard';
    // Landing fijado por el catálogo (backend) para roles sin Panel: operador -> Ventas, etc.
    // Con el menú congelado solo vale si sigue siendo una pantalla del menú.
    if (settings.landing && (!visible || routes.indexOf(settings.landing) !== -1)) return settings.landing;
    // Fallback (usuarios sin `landing` aún): primer ítem del menú derivado por CÓDIGOS
    // (mismo catálogo que el menú lateral), no del `accesses` legacy.
    return routes[0] || "/dashboard";
}
